module.exports = __webpack_public_path__ + "img/75675.049452e9.svg";